var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStyleToggleListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18758 8.45891L5.7578 1.39271C5.78906 1.30695 5.87066 1.25 5.96163 1.25H7.21271C7.30404 1.25 7.38563 1.30695 7.41654 1.39271L9.98676 8.45891C10.0382 8.60059 9.93329 8.75024 9.78293 8.75024H8.64575C8.55408 8.75024 8.47248 8.69295 8.44157 8.60649L7.97628 7.312C7.94538 7.22589 7.86343 7.16825 7.77211 7.16825H5.39425C5.30223 7.16825 5.22029 7.22624 5.18973 7.31304L4.73242 8.60545C4.70187 8.69226 4.61992 8.75024 4.5279 8.75024H3.39176C3.24106 8.75024 3.13619 8.60059 3.18793 8.45891H3.18758ZM6.09184 5.64875H7.06618C7.21619 5.64875 7.32105 5.50014 7.2707 5.35881L6.78631 3.99835C6.71791 3.80633 6.44672 3.80599 6.37762 3.99766L5.88767 5.35812C5.83663 5.49944 5.94149 5.64875 6.09184 5.64875Z",
    fill: "#B4B9B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.26468V6.73512C0 6.95684 0.285249 7.08017 0.477638 6.94142L2.88964 5.2062C3.03679 5.10056 3.03679 4.89924 2.88964 4.79314L0.477638 3.05838C0.285249 2.92009 0 3.04296 0 3.26468Z",
    fill: "#231E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleToggleListIcon);
export default __webpack_public_path__ + "static/media/StyleToggleListIcon.99f456712bb92261b0357b91843cd466.svg";
export { ForwardRef as ReactComponent };